export default async function useApi(
  url: string,
  method: 'GET' | 'POST' | 'PUT' | 'DELETE',
  body?: any,
  isForm?: boolean,
  tenantId?: string,
  hasNoAuth?: boolean,
  customToken?: string,
  // Best-effort calls pass this so a failure stays silent instead of putting an
  // error toast in front of the user over something they did not ask for.
  isSilent?: boolean
) {
  const { apiBaseUrl } = useAppConfig()
  const { user, contact, logout } = useUserStore()
  const isContactUrl = url.startsWith('css/') || url.startsWith('public/')

  try {
    const response = await $fetch<any>(`${apiBaseUrl}${url}`, {
      method,
      headers: {
        accept: 'application/json',
        'X-Tenant': `${tenantId || (isContactUrl ? contact.tenantId : user.tenant_identifier)}`,
        ...(hasNoAuth
          ? {}
          : {
              Authorization: `Bearer ${
                customToken || (isContactUrl ? contact.token : user.api_token)
              }`
            }),
        ...(body && !isForm ? { 'Content-Type': 'application/json' } : {})
      },
      body: isForm ? body : JSON.stringify(body)
    })

    return response
  } catch (error: any) {
    // Extract error details
    const errorData = error
    const errorFields = errorData?.data?.errors || { message: [errorData?.data?.message ?? ''] }

    // Display error details to the user
    if (!isSilent) {
      Object.keys(errorFields).forEach((field) => {
        toast.value?.add({
          severity: 'error',
          summary: 'Fehler',
          detail: errorFields?.[field]?.[0] || 'Unknown error',
          life: TOAST_LIFE_TIME_MS
        })
      })
    }

    // A silent call still has to log out on 401, it just does it quietly.
    if (error.statusCode === 401) {
      logout()
      return {}
    }
  }
}
